import { REQUEST_VALID_CODE_FACEBOOK } from "./constants";

export const requestValidCode = (code, integration) => ({
  type: REQUEST_VALID_CODE_FACEBOOK,
  payload: { code, integration },
});
